





















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import StartMixins from './mixins';

@Component
export default class StartPage extends mixins(Vue, StartMixins) {}
